import { createContext, useContext } from 'react';

export const LayoutContext = createContext({ opened: true, toggle: () => {} });

export const useLayoutContext = () => useContext(LayoutContext);
